var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleForms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#969DFF",
  d: "M53.474 42.105H31.579c-5.814 0-10.526 4.713-10.526 10.527s4.712 10.526 10.526 10.526h21.895C59.287 63.158 64 58.445 64 52.632c0-5.814-4.713-10.527-10.526-10.527"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B8C0FF",
  d: "M21.053 52.632c0-5.814-4.713-10.527-10.527-10.527S0 46.818 0 52.632s4.713 10.526 10.526 10.526c5.814 0 10.527-4.713 10.527-10.526"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#5746E3",
  d: "M21.053 31.579c0-5.814-4.713-10.526-10.527-10.526S0 25.765 0 31.579c0 5.813 4.713 10.526 10.526 10.526 5.814 0 10.527-4.712 10.527-10.526M53.474 21.053H31.579c-5.814 0-10.526 4.712-10.526 10.526 0 5.813 4.712 10.526 10.526 10.526h21.895C59.287 42.105 64 37.393 64 31.58s-4.713-10.526-10.526-10.526"
})), /*#__PURE__*/React.createElement("mask", {
  id: "google-forms_svg__a",
  width: 43,
  height: 22,
  x: 21,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#5F54F4",
  d: "M53.474 0H31.579c-5.814 0-10.526 4.713-10.526 10.526 0 5.814 4.712 10.527 10.526 10.527h21.895C59.287 21.053 64 16.34 64 10.526S59.287 0 53.474 0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-forms_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7372FE",
  d: "M53.474 0H31.579c-5.814 0-10.526 4.713-10.526 10.526 0 5.814 4.712 10.527 10.526 10.527h21.895C59.287 21.053 64 16.34 64 10.526S59.287 0 53.474 0"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#google-forms_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#64AFFF",
  d: "M15.158 25.684c8.371 0 15.158-6.786 15.158-15.158S23.529-4.632 15.158-4.632C6.786-4.632 0 2.155 0 10.526c0 8.372 6.786 15.158 15.158 15.158"
})))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7372FE",
  d: "M21.053 10.526C21.053 4.713 16.34 0 10.526 0S0 4.713 0 10.526c0 5.814 4.713 10.527 10.526 10.527 5.814 0 10.527-4.713 10.527-10.527"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M53.474 8a2.526 2.526 0 0 1 0 5.053H31.579a2.526 2.526 0 1 1 0-5.053zM10.526 15.579a5.053 5.053 0 1 0 0-10.105 5.053 5.053 0 0 0 0 10.105"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "google-forms_svg__b",
  width: 69.796,
  height: 69.796,
  x: -19.74,
  y: -24.372,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_8782_19908",
  stdDeviation: 9.87
})))));
export default SvgGoogleForms;